import React from 'react';

import { MaterialIcon } from '../../MaterialIcon/MaterialIcon';

type TagProps = React.ButtonHTMLAttributes<HTMLButtonElement>;

export interface IToggleButton extends Pick<TagProps, Exclude<keyof TagProps, 'onMouseEnter' | 'onMouseLeave' | 'onFocus' | 'onBlur'>> {
  primaryIcon: string;
  secondaryIcon: string;
}

interface IUiState {
  icon: string;
}

export class ToggleButton extends React.PureComponent<IToggleButton, IUiState> {

  constructor(props: IToggleButton, context?: any) {
    super(props, context);

    this.state = { icon: props.primaryIcon };
  }

  componentDidUpdate(prevProps: Readonly<IToggleButton>) {
    if (prevProps.primaryIcon !== this.props.primaryIcon) {
      this.setState({ icon: this.props.primaryIcon });
    }
  }

  render() {
    const { primaryIcon, secondaryIcon, ...props } = this.props;

    return (
      <button
        {...props}
        onMouseEnter={this.onActivate}
        onMouseLeave={this.onDeactivate}
        onFocus={this.onActivate}
        onBlur={this.onDeactivate}
      >
        <MaterialIcon icon={this.state.icon} />
      </button>
    );
  }

  private readonly onActivate = () => this.setState({ icon: this.props.secondaryIcon });

  private readonly onDeactivate = () => this.setState({ icon: this.props.primaryIcon });
}
